export type LocationType = 'Urban' | 'Suburban' | 'Rural';

export function getLocationTypeProximityRequirementMiles(
  locationType: LocationType | undefined,
): number | undefined {
  if (!locationType) return undefined;
  switch (locationType) {
    case 'Urban':
      return 0.5;
    case 'Suburban':
      return 1;
    case 'Rural':
      return 10;
    default:
      return undefined;
  }
}

function formatMiles(miles: number): string {
  if (miles === 1 || miles < 1) return `${miles} mile`;
  return `${miles} miles`;
}

export { formatMiles };

export function formatProximityRequirementTooltip(
  locationType: LocationType,
  requirementMiles: number,
): string {
  return `Exceeds ${formatMiles(requirementMiles)} suggested for ${locationType} locations`;
}

export function formatProximityRequirementRadiusTooSmall(
  locationType: LocationType,
  requirementMiles: number,
): string {
  return `For ${locationType} locations, properties in a ${formatMiles(requirementMiles)} mile radius are recommended (in green)`;
}

export function formatProximityRequirementPolygonTooSmall(
  locationType: LocationType,
  requirementMiles: number,
): string {
  return `Your selection is outside the recommended ${formatMiles(requirementMiles)} for ${locationType} locations.`;
}
